import { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Container } from '@mantine/core';
import { Footer } from '@/components/Footer';
import LayoutUnknownRoutes from '@/components/layout/LayoutUnknownRoutes';
import NavbarEvents from '@/components/Navbar/NavbarEvents';
import PaymentFeedback from '@/pages/events/paymentFeedback.page';
import { SuspensedView } from './SuspensedView';

const HomePage = lazy(() => import('@/pages/home'));
const WelcomeRegister = lazy(() => import('@/pages/auth/welcomeRegister'));
const Register = lazy(() => import('@/pages/auth/register'));
const LoginPage = lazy(() => import('@/pages/auth/login'));
const ForgotPassword = lazy(() => import('@/pages/auth/forgotPassword'));
const ResetPasswordPage = lazy(() => import('@/pages/auth/resetPassword'));
const NotFoundPage = lazy(() => import('@/pages/notFoundError/notFound.page'));
const PrivacyPolicy = lazy(() => import('@/pages/home/PrivacyPolicy'));
const ConfirmTestEmailPage = lazy(() => import('@/pages/notifications/confirmTestEmail.page'));
const EventDetailsPage = lazy(() => import('@/pages/events/eventDetails'));
const EventInscription = lazy(() => import('@/pages/events/eventInscription'));
const Leaderboard = lazy(() => import('@/pages/dashboard/organizer/leaderboard'));
const EventPublicWods = lazy(() => import('@/pages/events/eventPublicWods.page'));
const EventPublicHeats = lazy(() => import('@/pages/events/eventPublicHeats.page'));
const EventPayment = lazy(() => import('@/pages/events/eventPayment'));
const EventPaymentStatus = lazy(() => import('@/pages/events/eventPaymentStatus'));
const PaymentPixQrCode = lazy(() => import('@/pages/events/paymentPixQrCode'));
const PaymentPage = lazy(() => import('@/components/layout/LayoutPayment'));
const InscriptionFinishedPage = lazy(() => import('@/pages/events/inscriptionFinished'));
const PaymentRedirectMercadoPago = lazy(
  () => import('../pages/dashboard/payment/paymentRedirectMercadoPago.page')
);

const UnknownUserRoutes = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <SuspensedView>
            <HomePage />
          </SuspensedView>
        }
      />

      <Route
        path="login"
        element={
          <SuspensedView>
            <LoginPage />
          </SuspensedView>
        }
      />

      <Route
        path="bemvindo-cadastro"
        element={
          <SuspensedView>
            <WelcomeRegister />
          </SuspensedView>
        }
      />

      <Route
        path="cadastro"
        element={
          <SuspensedView>
            <Register />
          </SuspensedView>
        }
      />

      <Route
        path="forgotpassword"
        element={
          <SuspensedView>
            <ForgotPassword />
          </SuspensedView>
        }
      />

      <Route
        path="resetpassword"
        element={
          <SuspensedView>
            <ResetPasswordPage />
          </SuspensedView>
        }
      />
      <Route
        path="confirmar-email-teste/:token"
        element={
          <SuspensedView>
            <ConfirmTestEmailPage />
          </SuspensedView>
        }
      />
      <Route
        path="politicas-de-privacidade"
        element={
          <SuspensedView>
            <PrivacyPolicy />
          </SuspensedView>
        }
      />

      <Route
        path="evento/metodo-pagamento/pix-qrcode"
        element={
          <SuspensedView>
            <PaymentPixQrCode />
          </SuspensedView>
        }
      />

      <Route
        path="feedback-sucesso"
        element={
          <SuspensedView>
            <PaymentFeedback />
          </SuspensedView>
        }
      />

      <Route
        path="evento/:eventId/leaderboard"
        element={
          <SuspensedView>
            <NavbarEvents />
            <Container
              size="xl"
              mt={10}
              style={{
                minHeight: `80vh`,
              }}
            >
              <Leaderboard />
            </Container>
            <Footer style={{ bottom: 0, left: 0, width: '100%' }} />
          </SuspensedView>
        }
      />

      {/* Baterias publicadas: horário, arena e raia de cada equipe */}
      <Route
        path="evento/:eventId/baterias"
        element={
          <SuspensedView>
            <NavbarEvents />
            <Container size="xl" mt={10} style={{ minHeight: `80vh` }}>
              <EventPublicHeats />
            </Container>
            <Footer style={{ bottom: 0, left: 0, width: '100%' }} />
          </SuspensedView>
        }
      />

      {/* WODs publicados do evento, com vídeo e standards de cada movimento */}
      <Route
        path="evento/:eventId/wods"
        element={
          <SuspensedView>
            <NavbarEvents />
            <Container size="xl" mt={10} style={{ minHeight: `80vh` }}>
              <EventPublicWods />
            </Container>
            <Footer style={{ bottom: 0, left: 0, width: '100%' }} />
          </SuspensedView>
        }
      />

      {/* Página do evento: cabeçalho e rodapé do rebranding, cores do organizador */}
      <Route
        path="evento/:eventId"
        element={
          <SuspensedView>
            <EventDetailsPage />
          </SuspensedView>
        }
      />

      <Route element={<LayoutUnknownRoutes />}>
        <Route
          path="evento/:eventId/*"
          element={
            <SuspensedView>
              <PaymentPage />
            </SuspensedView>
          }
        >
          <Route
            path="categoria/:categoryId/lote/:eventLotId/inscricao/:inscricaoId?"
            element={
              <SuspensedView>
                <EventInscription />
              </SuspensedView>
            }
          />
          <Route
            path="categoria/:categoryId/lote/:eventLotId/inscricao/:inscricaoId/metodo-pagamento/cupom/:cupomId?"
            element={
              <SuspensedView>
                <EventPayment />
              </SuspensedView>
            }
          />
          <Route
            path="redirect-mp"
            element={
              <SuspensedView>
                <PaymentRedirectMercadoPago />
              </SuspensedView>
            }
          />
        </Route>
      </Route>

      <Route
        path="inscricao-atleta/inscricao/:inscricaoId/evento/:eventId"
        element={
          <SuspensedView>
            <InscriptionFinishedPage />
          </SuspensedView>
        }
      />

      <Route
        path="status-pagamento/:paymentId/cadastro/:inscriptionId/evento/:eventId"
        element={
          <SuspensedView>
            <EventPaymentStatus />
          </SuspensedView>
        }
      />
      <Route
        path="*"
        element={
          <SuspensedView>
            <NotFoundPage />
          </SuspensedView>
        }
      />
    </Routes>
  );
};

export { UnknownUserRoutes };
